import { useSuspenseQuery } from "@tanstack/react-query";

import { ReactQueryKeysGlobal } from "../queryKeys";
import { getMyAccounts } from "./getAccounts";

export const useAccounts = () => {
  const { data } = useSuspenseQuery({
    queryKey: [ReactQueryKeysGlobal.myAccounts],
    queryFn: () => getMyAccounts(),
    retryOnMount: false,
  });
  return data || [];
};
